// extracted by mini-css-extract-plugin
module.exports = {"spaceBetween":"flex-spaceBetween","flex":"flex-flex","one":"flex-one","justifyEnd":"flex-justifyEnd","alignEnd":"flex-alignEnd","alignCenter":"flex-alignCenter"};